import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import axios from "axios";
import ModalVideo from 'react-modal-video'
import {
  img_500,
  unavailable,
  unavailableLandscape,
} from "../../config/config";
import "./ContentModal.css";
import { Button } from "@material-ui/core";
import YouTubeIcon from "@material-ui/icons/YouTube";
import Carousel from "../Carousel/Carousel";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "90%",
    height: "80%",
    backgroundColor: "#39445a",
    border: "1px solid #282c34",
    borderRadius: 10,
    color: "white",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 3),
  },
}));

export default function TransitionsModal({ children, media_type, id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [video, setVideo] = useState();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const f = () => {
    // setOpen(false);
    setIsOpen(true);
  }
  const fetchData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/${media_type}/${id}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );

    setContent(data);
    // console.log(data);
  };

  const fetchVideo = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/${media_type}/${id}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );

    setVideo(data.results[0]?.key);
  };

  useEffect(() => {
    fetchData();
    fetchVideo();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div
        className="media"
        style={{ cursor: "pointer" }}
        color="inherit"
        onClick={handleOpen}
      >
        {children}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          {(content && (!isOpen)) ? (
            <div className={classes.paper}>
              <div className="ContentModal">
                <img
                  src={
                    content?.poster_path
                      ? `${img_500}/${content?.poster_path}`
                      : unavailable
                  }
                  alt={content?.name || content?.title}
                  className="ContentModal__portrait"
                />
                <img
                  src={
                    content?.backdrop_path
                      ? `${img_500}/${content?.backdrop_path}`
                      : unavailableLandscape
                  }
                  alt={content?.name || content?.title}
                  className="ContentModal__landscape"
                />
                <div className="ContentModal__about">
                  <span className="ContentModal__title">
                    {content?.name || content?.title} (
                    {(
                      content?.first_air_date ||
                      content?.release_date ||
                      "-----"
                    ).substring(0, 4)}
                    )
                  </span>
                  {content?.tagline && (
                    <i className="tagline">{content?.tagline}</i>
                  )}

                  <span className="ContentModal__description">
                    {content?.overview}
                  </span>

                  <div>
                    <Carousel id={id} media_type={media_type} />
                  </div>

                  <Button
                    variant="contained"
                    startIcon={<YouTubeIcon />}
                    color="secondary"
                    target="__blank"
                    onClick={f}
                  >
                    Watch the Trailer
                  </Button>
                </div>
              </div>
            </div>
          ) :
            (
              <div className={classes.paper}>
                  
                  {/* <div style={{position:'absolute',top:'0',bottom:'0',width:'100%',height:'100%'}}> */}
                  {/* <ModalVideo  channel='youtube' autoplay isOpen={isOpen} videoId={video} onClose={() => setIsOpen(false)} /> */}
                  {/* </div>              */}

                <iframe  width='100%' height='95%' src={`https://www.youtube.com/embed/${video}`} title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                <Button variant="contained" size="large" color="secondary" onClick={()=>setIsOpen(false)}>Close</Button>
              </div>



            )
          }


        </Fade>

      </Modal>

    </>
  );
}
